import { InjectionToken } from '@angular/core';

export interface CurrencyExchange {
  exchange: {
    rate: string;
    targetIsoCode: string;
  }
}

export interface PriceConfigToken {
  dblCurrencyActivated: boolean;
  conversionRate: number;
  currencyIsocode: string;
  lang?: string;
  currencies?: Record<string, CurrencyExchange>;
}

export const PRICE_CONFIG = new InjectionToken<PriceConfigToken>(
  'PRICE_CONFIG'
);
